// src/utils/dateUtils.ts
import { format as dateFnsFormat } from 'date-fns';
import { enUS, zhCN, th } from 'date-fns/locale';
import i18nInstance from '../i18n';

// Map of language codes to date-fns locales
const localeMap = {
  en: enUS,
  zh: zhCN,
  th: th
};

/**
 * Format a date with the current language locale
 * @param date The date to format
 * @param formatStr The date-fns format string
 * @returns The formatted date string
 */
export const formatDateLocale = (date: Date | string | number, formatStr: string): string => {
  if (!date) return '';
  
  const dateObj = typeof date === 'string' || typeof date === 'number' 
    ? new Date(date) 
    : date;
    
  // Get the current language from i18next
  const currentLang = i18nInstance.language || 'en';
  
  // Get the corresponding date-fns locale
  const locale = localeMap[currentLang as keyof typeof localeMap] || enUS;
  
  return dateFnsFormat(dateObj, formatStr, { locale });
};